import React from "react";
import "./PopUp.scss";
import { useTranslation } from "react-i18next";

interface PopUpProps {
  content?: React.ReactNode;
  title?: string;
  message?: string;
  onConfirm?: () => void;
  onCancel: () => void; 
  open: boolean;
  customClass?: string;
  confirmText?: string;
}

const PopUp: React.FC<PopUpProps> = ({
  title,
  message,
  onConfirm,
  onCancel,
  open,
  content,
  customClass,
  confirmText
}) => {
  const { t } = useTranslation();
  const getText = (text: string) => t(`popUp.${text}`);

  if (!open) return null; 
  return (
    <div className="popup-overlay" onClick={onCancel}>
      <div
        className={`popup-container ${customClass || ""}`} 
        onClick={(e) => e.stopPropagation()} 
      >
        <button className="popup-close" onClick={onCancel}>
          &times;
        </button>
        {title && <h3>{title}</h3>}
        {content ? content : <p>{message}</p>}
        {onConfirm && (
          <div className="popup-actions">
            <button className="cancel-button" onClick={onCancel}>
              {getText("cancel")}
            </button>
            <button
              className="btn btn-primary confirm-button"
              onClick={onConfirm}
            >
              {confirmText || getText("change")}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default PopUp;
